import type { GenericOptions } from "contract-generator";

export type Message =
  | ResizeMessage
  | TabChangeMessage
  | ParentStyleMessage
  | ParentLocationChangeMessage
  | ParentDomainMessage
  | ParentCopyMessage;

export interface ResizeMessage {
  kind: "oz-wizard-resize";
  height: number;
}

export interface TabChangeMessage {
  kind: "oz-wizard-tab-change";
  tab: string;
}

export interface ParentStyleMessage {
  kind: "oz-wizard-style";
  style: string;
  useChildStyle: boolean;
}

export interface ParentLocationChangeMessage {
  kind: "oz-wizard-export-contract-location";
  url: string;
}

export interface ParentDomainMessage {
  kind: "oz-wizard-export-contract-parent-domain";
  url: string;
}

export interface ParentCopyMessage {
  kind: "oz-wizard-clipboard-code-text";
  text: string;
  opts: Required<GenericOptions> | undefined;
  language: "solidity";
}

export function postMessage(msg: Message) {
  if (parent) {
    parent.postMessage(msg, "*");
  }
}

export function postMessageToParent(msg: Message) {
  if (window.self === window.parent) {
    console.log(`window don't have iframe parent.`);
    return;
  }

  postMessage(msg);
}

export function postMessageToChild(
  iframe: HTMLIFrameElement | null,
  msg: Message
) {
  if (iframe) {
    iframe!.contentWindow?.postMessage(msg, "*");
  }
}
